import { createContext } from 'react';

export interface ChromeFoldContextValue {
  folded: boolean;
  setFolded: (folded: boolean) => void;
}

// ENG-2551: lets an ordering step signal that it has "folded" the page chrome
// (slim incentive tracker, reduced layout margin) so the step content owns the
// mobile viewport. Default is a no-op so components mounted outside V3Layout
// (Storybook mounts OrderRouter directly) work unchanged.
const ChromeFoldContext = createContext<ChromeFoldContextValue>({
  folded: false,
  setFolded: () => {},
});

export default ChromeFoldContext;
